import React, { Component } from "react";
import doctorLogo from "./icons/doctor.svg";
import "./index.css";
import PropTypes from "prop-types";

class NotFound extends Component {
  render() {
    const { logo = doctorLogo, msg } = this.props;
    return (
      <div className="not-found">
        <img className="not-found__img" src={logo} alt="" />
        <div className="not-found__msg">{msg}</div>
      </div>
    );
  }
}

NotFound.propTypes = {
  logo: PropTypes.string,
  msg: PropTypes.string.isRequired,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js